import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr);
import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe);
import localeUs from '@angular/common/locales/en';
registerLocaleData(localeUs);
import { HTTP_INTERCEPTORS, HttpBackend, HttpClientModule } from '@angular/common/http';
import { NavigationError, provideRouter, Router, withNavigationErrorHandler } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';

import { NgxsStoreModule } from './core/ngxs/ngxs.module'
import { AuthorizationInterceptor } from './core/interceptors/auth.interceptor';
import { routes } from './app.routes';
import { provideScrollbarOptions } from 'ngx-scrollbar';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export function HttpLoaderFactory(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, ['/assets/i18n/']);
}

export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const chunkLoadError = /ChunkLoadError/;
    const dynamicImportError = /error loading dynamically imported module/i;
    
    if (chunkFailedMessage.test(error?.message) || 
        chunkLoadError.test(error?.name) ||
        dynamicImportError.test(error?.message)) {
      console.warn('Chunk loading failed, performing hard reload...');
      window.location.reload();
      return;
    }
    
    console.error(error);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true},
    {provide: ErrorHandler, useClass: ChunkErrorHandler},
    provideScrollbarOptions({visibility: 'hover', appearance: 'compact'}),
    provideRouter(routes, withNavigationErrorHandler((error: NavigationError) => {
      if (error.error?.message?.includes('error loading dynamically imported module') ||
          error.error?.name === 'ChunkLoadError') {
        console.warn('Navigation chunk loading failed, reloading to:', error.url);
        window.location.href = error.url;
      }
    })),
    importProvidersFrom([
      HttpClientModule,
      NgxsStoreModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpBackend]
        },
        defaultLanguage: 'en'
      }),
      TranslatePipe
    ]),
    provideAnimations(),
  ]
};
